export function LoadingSpinner({ size = 'small', color = '#8F52F1' }) {
    const sizeClasses =
        size === 'large'
            ? 'h-10 w-10'
            : size === 'medium'
            ? 'h-6 w-6'
            : 'h-4 w-4';

    return (
        <svg
            className={`${sizeClasses} animate-spin`}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                className="opacity-100"
                cx="12"
                cy="12"
                r="10"
                stroke="white"
                strokeWidth="2"
            />
            <path
                className="opacity-100"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                d="M22 12a10 10 0 00-10-10"
            />
        </svg>
    );
}
